import React, { useEffect, useState } from 'react';

function InvoiceHistoryPage({role, invoiceId, onBack }) {
  const [invNo, setInvNo] = useState("");
  const [invoices, setInvoices] = useState([]);

  // Global Logs Toggle
  const [showAllLogs, setShowAllLogs] = useState(true);

  // Modal states
  const [showDocModal, setShowDocModal] = useState(false);
  const [currentDocs, setCurrentDocs] = useState([]);

  // Mapping for role display
  const roleDisplayMap = {
    admin: "Marketing Department",
    accounts_1st: "Account Office",
    accounts_2nd: "CFAO",
    accounts_3rd: "President",
    final_accountant: "Account Office 2",
  };

  useEffect(() => {
    fetch(`https://approvals.sigma.ac.in/backend/api/logs/invoice/${invoiceId}`, {
      headers: { "Authorization": "Bearer " + localStorage.getItem("auth_token") }
    })
      .then(res => res.json())
      .then(data => {
        setInvNo(data.inv_no || "");
        setInvoices(data.invoices || []);
      });
  }, [invoiceId]);

  const openDocumentModal = (invoice) => {
    const docs = JSON.parse(invoice.document || "[]");
    setCurrentDocs(docs);
    setShowDocModal(true);
  };

  const handlePrintEntirePage = () => {
    const printWindow = window.open('', '_blank');
    
    // Get the print area content
    const printArea = document.getElementById('print-area');
    let htmlContent = printArea.innerHTML;

    const fullHTML = `
      <!DOCTYPE html>
      <html>
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Invoice History - Print</title>
        <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css">
        <style>
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }
          body {
            font-family: Arial, sans-serif;
            line-height: 1.6;
            color: #333;
            background: white;
            padding: 20px;
          }
          header, button, .modal, [style*="position: fixed"] {
            display: none !important;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin: 15px 0;
          }
          th, td {
            padding: 10px;
            border-bottom: 1px solid #ddd;
            text-align: left;
          }
          th {
            background: #f6f6f6 !important;
            font-weight: bold;
          }
          @media print {
            body {
              margin: 0;
              padding: 10px;
            }
          }
        </style>
      </head>
      <body>
        ${htmlContent}
      </body>
      </html>
    `;

    printWindow.document.write(fullHTML);
    printWindow.document.close();
    
    setTimeout(() => {
      printWindow.print();
    }, 250);
  };

  // Shared styles for better spacing and consistency
  const cardStyle = {
    border: '1px solid #e0e0e0',
    padding: 18,
    borderRadius: 10,
    overflowY: 'auto',
    marginBottom: 20,
    background: '#fff',
    boxShadow: '0 1px 4px rgba(10,10,10,0.06)'
  };

  const tableStyle = { width: '100%', marginBottom: 14, borderCollapse: 'separate', borderSpacing: '0 6px' };
  const cellStyle = { padding: '8px 10px', verticalAlign: 'top' };
  const actionTableStyle = { width: '100%', borderCollapse: 'collapse' };
  const primaryButtonStyle = { background: '#007bff', padding: '6px 12px', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', textDecoration: 'none' };
  const linkButtonStyle = { background: '#28a745', color: 'white', padding: '5px 10px', borderRadius: '6px', textDecoration: 'none' };

  return (
        <>
      {/* ===== PRINT CSS ADDED HERE ===== */}
      <style>
        {`
          @media print {
            body {
              margin: 0;
              padding: 0;
            }

            .container {
              overflow: visible !important;
              height: auto !important;
            }

            header,
            button {
              display: none !important;
            }

            #print-area {
              width: 100%;
            }

            .print-page {
              page-break-after: always;
              break-after: page;
            }

            table {
              page-break-inside: avoid;
            }
          }
        `}
      </style>
    <div id="print-area" className="container" style={{ position: "relative", padding: 16, overflowY: "auto", height: "100%" }}>

      {/* ========== HEADER ========== */}
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: '#085EE3',
          color: 'white',
          padding: '10px 16px',
          borderRadius: 8,
          marginBottom: 18,
          boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          {/* Simple SVG logo */}
          {/* <div style={{ width: 36, height: 36, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'white', borderRadius: 6 }}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="#085EE3" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zM13 21h8V11h-8v10zm0-18v6h8V3h-8z" />
            </svg>
          </div> */}
          <div>
            <div style={{ fontWeight: 700, fontSize: 16 }}>Invoice History</div>
            <div style={{ fontSize: 12, opacity: 0.9 }}>(INV No: {invNo})</div>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {role !== 'admin' && (
            <button
              onClick={handlePrintEntirePage}
              aria-label="Print"
              title="Print Entire Page"
              style={{
                background: 'white',
                color: '#085EE3',
                padding: '6px 12px',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8
              }}
            >
              <i className="fas fa-print" aria-hidden="true" style={{ color: '#085EE3', fontSize: 14 }}></i>
             
            </button>
          )}
          <button
            onClick={onBack}
            aria-label="Back"
            style={{
              background: 'white',
              color: '#085EE3',
              padding: '6px 12px',
              borderRadius: 6,
              border: 'none',
              cursor: 'pointer'
            }}
          >
            ← Back
          </button>

          <button
            onClick={() => setShowAllLogs(!showAllLogs)}
            aria-pressed={showAllLogs}
            style={{
              background: showAllLogs ? '#063ea8' : '#ffffff',
              color: showAllLogs ? 'white' : '#085EE3',
              padding: '6px 12px',
              borderRadius: 6,
              border: 'none',
              cursor: 'pointer'
            }}
          >
            {showAllLogs ? 'Hide All Logs ▲' : 'Show All Logs ▼'}
          </button>
        </div>
      </header>

      {/* <hr style={{ marginTop: 0, marginBottom: 18 }} /> */}

      {invoices.length === 0 && <p>No invoices found.</p>}

      {invoices.map((invoice, index) => {

        const prev = index < invoices.length - 1 ? invoices[index + 1] : null;

        const changed = (field) =>
          prev && invoice[field] !== prev[field];

        return (
          <div key={invoice.id} style={cardStyle}>

            {/* ========== SUMMARY TABLE ========== */}
            <table style={tableStyle}>
              <tbody>
      {/* Show final document if present */}
      {invoice?.final_document && (
        <div style={{ margin: '14px 0' }}>
          <a
            href={`https://approvals.sigma.ac.in/backend/storage/${invoice.final_document}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#28A745', fontWeight: 600 }}
          >
            View Final Document
          </a>
        </div>
      )}

                <tr>
                  <td style={cellStyle}><b>Company:</b></td>
                  <td style={{ ...cellStyle, background: changed("title") ? "#ffe5a0" : "" }}>
                    {invoice.title}
                  </td>

                  <td style={cellStyle}><b>Department:</b></td>
                  <td style={cellStyle}>{invoice.department}</td>
                </tr>

                <tr>
                  <td style={cellStyle}><b>Status:</b></td>
                  <td style={cellStyle}>{invoice.status}</td>

                  <td style={cellStyle}><b>Invoice Type:</b></td>
                  <td style={{ ...cellStyle, background: changed("inv_type") ? "#ffe5a0" : "" }}>
                    {invoice.inv_type}
                  </td>
                </tr>

                <tr>
                  <td style={cellStyle}><b>Invoice No:</b></td>
                  <td style={{ ...cellStyle, background: changed("inv_no") ? "#ffe5a0" : "" }}>
                    {invoice.inv_no}
                  </td>

                  <td style={cellStyle}><b>Invoice Amount:</b></td>
                  <td style={{ ...cellStyle, background: changed("inv_amt") ? "#ffe5a0" : "" }}>
                    ₹ {invoice.inv_amt}
                  </td>
                </tr>

                <tr>
                  <td style={cellStyle}><b>Current Role:</b></td>
                  <td style={cellStyle}>{roleDisplayMap[invoice.current_role] || invoice.current_role}</td>

                  <td style={cellStyle}><b>Comment:</b></td>
                  <td style={{ ...cellStyle, background: changed("comment") ? "#ffe5a0" : "" }}>
                    {invoice.comment || "-"}
                  </td>
                </tr>

                {/* DOCUMENT BUTTON */}
                <tr>
                  <td style={cellStyle}><b>Document(s):</b></td>
                  <td colSpan="3" style={cellStyle}>
                    <button onClick={() => openDocumentModal(invoice)} style={primaryButtonStyle}>
                      📄 Show Documents
                    </button>
                  </td>
                </tr>

              </tbody>
            </table>

            {/* ========== ACTION HISTORY (Global Toggle) ========== */}
            {showAllLogs && (
              <div>
                <h4>Action History</h4>

                {invoice.logs.length === 0 && <p>No logs found.</p>}

                {invoice.logs.length > 0 && (
                  <table style={actionTableStyle}>
                    <thead>
                      <tr style={{ background: "#f6f6f6" }}>
                        <th style={{ ...cellStyle, textAlign: 'left' }}>Time</th>
                        <th style={{ ...cellStyle, textAlign: 'left' }}>User/Role</th>
                        <th style={{ ...cellStyle, textAlign: 'left' }}>Action</th>
                        <th style={{ ...cellStyle, textAlign: 'left' }}>Rejected To</th>
                        <th style={{ ...cellStyle, textAlign: 'left' }}>Comment</th>
                        {role == 'accounts_3rd' && (
                        <th style={{ ...cellStyle, textAlign: 'left' }}>Query</th>
                        )}
                      </tr>
                    </thead>
                    <tbody>
                      {invoice.logs.map(log => (
                        <tr key={log.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                          <td style={cellStyle}>{new Date(log.created_at).toLocaleString()}</td>
                          <td style={cellStyle}>{log.user?.name || (roleDisplayMap[log.role] || log.role)}</td>
                          <td style={cellStyle}><b>{log.action.toUpperCase()}</b></td>
                          <td style={cellStyle}>{roleDisplayMap[log.rejected_to] || "-"}</td>
                          <td style={cellStyle}>{log.comment || "-"}</td>
                          {role == 'accounts_3rd' && (
                          <td style={cellStyle}>{log.query || "-"}</td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            )}

          </div>
        );
      })}

      {/* =============== DOCUMENT POPUP MODAL =============== */}
      {showDocModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "white",
              width: "500px",
              padding: "20px",
              borderRadius: "10px",
              maxHeight: "80vh",
              overflowY: "auto"
            }}
          >
            <h3>Documents</h3>
            <hr />

            {currentDocs.length === 0 ? (
              <p>No Documents</p>
            ) : (
              currentDocs.map((doc, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                    gap: "10px"
                  }}
                >
                  <b>Doc {index + 1}</b>

                  {/* View */}
                  <a
                    href={`https://approvals.sigma.ac.in/backend/storage/${doc}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={primaryButtonStyle}
                  >
                    👁️ View
                  </a>

                  {/* Download */}
                  <a
                    href={`https://approvals.sigma.ac.in/backend/api/download/${doc}`}
                    download
                    style={linkButtonStyle}
                  >
                    ⬇️ Download
                  </a>
                </div>
              ))
            )}

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
              <button
                onClick={() => setShowDocModal(false)}
                style={{
                  background: "red",
                  color: "white",
                  padding: "6px 14px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  border: "none"
                }}
              >
                Close
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
    </>
  );
}

export default InvoiceHistoryPage;
